import { css } from 'styled-components'
import { colors as c } from 'utils'

//per designers since the black menu on black screen disappears we are using not white/Almostblack, but instead white/pilePrimary
export default css`
  background: ${c('FloatingMenu')};
  box-shadow: 0px 2px 4px 0px #00000040;
  border-radius: 2px;
`
